App.OrderHistoryChangeComponent = Em.Component.extend
  classNames: 'order-history-change'

  store: Em.inject.service()
  env:   Em.inject.service('environment')

  name: null
  value: null

  isCourierChange: Em.computed.equal('name', 'courier_id')

  from: (->
    @get('value').objectAt(0)
  ).property('value')

  to: (->
    @get('value').objectAt(1)
  ).property('value')

  courierFrom: (->
    @get('humanizeFrom')
    @get('courierF')
  ).property('humanizeFrom', 'courierF')

  courierTo: (->
    @get('humanizeTo')
    @get('courierT')
  ).property('humanizeTo', 'courierT')

  translatedName: (->
    tr_name = "history.change_name.#{@get('name')}"
    if @get('env').has_translation_for tr_name
      @get('env').translate tr_name
    else
      @get('name')
  ).property('env','name')

  humanizeFrom: (->
    if @get('from')
      @parseValue(@get('from'), 'from')
  ).property('from', 'value[]')

  humanizeTo: (->
    if @get('to')
      @parseValue(@get('to'), 'to')
  ).property('to', 'value[]')

  parseValue:((v, t) ->
    switch @get('name')
      when "delivery_at", "cooking_start_at", "pick_up_at"
        date = moment(v)
        # оставить только полную дату?
        if moment().isSame(date, 'day')
          date.format('H:mm')
        else
          date.format('D MMMM, H:mm')
      when "status"
        tr_name = "order.status.#{v}"
        if @get('env').has_translation_for tr_name
          @get('env').translate tr_name
        else
          v
      when "courier_id"
        promise = @get('store').find('courier', v)
        promise.then((courier) =>
          if t == 'to'
            @set('courierT', promise.get('name'))
          else
            @set('courierF', promise.get('name'))
        )
      else v
  )